import axiosInstance from './axiosInstance';

const updateTopUpStatus = ({ id, nextState }) => {
  return axiosInstance.patch(`/internal/admin/top_up/${id}`, {
    next: nextState,
  });
};

export default updateTopUpStatus;
